import { createAction } from "@reduxjs/toolkit";

import {
  AuthorizePayload,
  GetProductDetailApiPayload,
  GetProductsApiPayload,
  UpdateCartApiPayload,
  UpdateShippingAddressApiPayload,
} from "./types";

import {
  ChangePasswordPayload,
  CheckoutApiPayload,
  GetBrandApiPayload,
  GetOrderDetailApiPayload,
  GetOrderHistoryApiPayload,
  GetPointHistoryApiPayload,
  GetProfilePayload,
  GetShippingDetailApiPayload,
  LangType,
  LoginPayload,
  ResetCheckedAllProductPayload,
  ResetPaginationPayload,
  ResetShippingAddressApiPayload,
} from "./types";

import * as payloadType from "./types/payload";

export const getProductsApi = createAction<GetProductsApiPayload>("getProductsApi");

export const getCheckoutProductsApi = createAction<GetProductsApiPayload>("getCheckoutProductsApi");

export const getProductDetailApi = createAction<GetProductDetailApiPayload>("getProductDetailApi");

export const getShippingDetailApi = createAction<GetShippingDetailApiPayload>("getShippingDetailApi");

export const resetShippingAddressApi = createAction<ResetShippingAddressApiPayload>("resetShippingAddressApi");

export const updateShippingAddressApi = createAction<UpdateShippingAddressApiPayload>("updateShippingAddressApi");

// export const getTopProductsApi = createAction<GetTopProductsApiPayload>('getTopProductsApi')

export const updateCartApi = createAction<UpdateCartApiPayload>("updateCartApi");

export const getProfile = createAction<GetProfilePayload>("getProfile");

export const checkoutApi = createAction<CheckoutApiPayload>("checkoutApi");

export const changePasswordApi = createAction<ChangePasswordPayload>("changePasswordApi");

export const getOrderHistoryApi = createAction<GetOrderHistoryApiPayload>("getOrderHistoryApi");

export const getPointHistoryApi = createAction<GetPointHistoryApiPayload>("getPointHistoryApi");

export const getOrderDetailApi = createAction<GetOrderDetailApiPayload>("getOrderDetailApi");

// export const getProductListingApi = createAction<GetProductsApiPayload>('getProductListingApi')

export const resetCheckedAllProduct = createAction<ResetCheckedAllProductPayload>("resetCheckedAllProduct");

export const resetPagination = createAction<ResetPaginationPayload>("resetPagination");

export const loginApi = createAction<LoginPayload>("loginApi");

export const accountStatusApi = createAction<LoginPayload>("accountStatusApi");

export const authorizeApi = createAction<AuthorizePayload>("authorizeApi");

export const getBrandApi = createAction<GetBrandApiPayload>("getBrandApi");

export const setStoreLanguage = createAction<LangType>("setStoreLanguage");

export const clearStore = createAction("clearStore");

export const getUserCartItemsApi = createAction<payloadType.GetUserCartPayload>("getUserCartItemsApi");

// export const addUserCartItemApi = createAction<payloadType.AddUserCartItemPayload>('addUserCartItemApi')

export const removeUserCartItemApi = createAction<payloadType.RemoveUserCartPayload>("removeUserCartItemApi");

export const updateUserCartItemApi = createAction<payloadType.UpdateUserCartPayload>("updateUserCartItemApi");

// export const updateLocalCartItem = createAction<payloadType.UpdateLocalUserCartItemPayload>('updateLocalCartItem')

export const postGetDailyBonusApi = createAction<payloadType.PostGetDailyBonusApiPayload>("postGetDailyBonusApi");

export const getBannerApi = createAction<payloadType.GetBannerPayload>("getBannerApi");

export const logout = createAction("logout");

export const resetLockedAccount = createAction("resetLockedAccount");

export const getVipStatus = createAction<payloadType.GetVipStatusPayload>("getVipStatus");

export const generateVipStatusToken = createAction<payloadType.GenerateVipStatusTokenPayload>("generateVipStatusToken");

export const redeemCredit = createAction<payloadType.redeemCreditPayload>("redeemCredit");

export const clearVipStatusData = createAction("clearVipStatusData");
